import { Children, useState } from 'react';

import SwipeableViews from 'react-swipeable-views';

import { Paper, Tabs } from '@mui/material';
import { useTheme } from '@classify/react-core-components/styles';
import { makeStyles } from '@mui/styles';

import TabBarContent from '../TabBarContent';
import TabBarItem from '../TabBarItem';
import TAB_BAR_VARIANTS from '../../constants/tabBarVariants';

const useStyles = makeStyles(
  () => ({
    tabs: {
      position: 'relative',
      zIndex: 2,
    },
  }),
  { classNamePrefix: 'TabBar' }
);

export default function TabBar({
  defaultSelectedTabIndex = 0,
  selectedTabIndex = null,
  onChange = () => {},
  children,
  isScrollable = false,
  variant = TAB_BAR_VARIANTS.DEFAULT,
  tabsClasses = null,
  paperClasses = null,
}) {
  const [selectedTabIndexState, setSelectedTabIndexState] = useState(defaultSelectedTabIndex);
  const selectedTabIndexToUse =
    selectedTabIndex === null ? selectedTabIndexState : selectedTabIndex;

  const updateSelectedTab = /* istanbul ignore next */ (newTabIndex) => {
    setSelectedTabIndexState(newTabIndex);
    onChange(newTabIndex);
  };

  const onTabChange = /* istanbul ignore next */ (event, newTabIndex) =>
    updateSelectedTab(newTabIndex);
  const onViewChange = /* istanbul ignore next */ (newTabIndex) => updateSelectedTab(newTabIndex);

  const { direction } = useTheme();

  const childrenAsArray = Children.toArray(children);

  const tabItems = childrenAsArray.filter((child) => child.type === TabBarItem);
  const tabContents = childrenAsArray.filter((child) => child.type === TabBarContent);

  const classes = useStyles();

  return (
    <div
      data-testid="tab-bar"
      style={{
        position: variant === TAB_BAR_VARIANTS.STICKY ? 'sticky' : null,
        top: variant === TAB_BAR_VARIANTS.STICKY ? '0' : null,
      }}
    >
      {!!tabItems.length && (
        <Paper className={classes.tabs} classes={paperClasses}>
          <Tabs
            classes={tabsClasses}
            variant={isScrollable ? 'scrollable' : 'fullWidth'}
            centered={!isScrollable}
            indicatorColor="primary"
            textColor="primary"
            value={selectedTabIndexToUse}
            onChange={onTabChange}
            scrollButtons="auto"
          >
            {tabItems}
          </Tabs>
        </Paper>
      )}
      {!!tabContents.length && (
        <SwipeableViews
          animateHeight
          axis={/* istanbul ignore next */ direction === 'rtl' ? 'x-reverse' : 'x'}
          index={selectedTabIndexToUse}
          onChangeIndex={onViewChange}
        >
          {tabContents}
        </SwipeableViews>
      )}
    </div>
  );
}

TabBar.Content = TabBarContent;
TabBar.Item = TabBarItem;
